class HomeNews extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        this.setup()
        this.interact()
    }
    setup() {
        new MasterTimeline({
            triggerInit: this,
            scrollTrigger: { trigger: this.querySelector('.home-news'), start: 'top top+=70%' },
            tweenArr: [
                new RevealText({ el: this.querySelector('.home-news-label .txt'), color: 'rgba(29, 29, 29, 0.80)', isFast: true }),
                new RevealTextReset({ el: this.querySelector('.home-news-title .txt'), color: 'black' }),
                new FadeIn({ el: this.querySelector('.home-news-nav') })
            ]
        })
        new MasterTimeline({
            triggerInit: this, scrollTrigger: { trigger: this.querySelector('.home-news-list') },
            tweenArr: [ new FadeIn({ el: this.querySelector('.home-news-list') }) ]
        })
    }
    interact() {
        this.querySelector('.home-news-list-wrap').classList.add('swiper');
        this.querySelector('.home-news-list-inner').classList.add('swiper-wrapper');
        this.querySelectorAll('.home-news-list-item').forEach((item) => item.classList.add('swiper-slide'));
        const newsSwiper = new Swiper(this.querySelector('.home-news-list-wrap'), {
            modules: [Navigation, Scrollbar, Pagination],
            autoHeight: true,
            slidesPerView: 1,
            spaceBetween: parseRem(16),
            pagination: {
                el: this.querySelector('.home-news-pagi'),
                bulletClass: 'home-news-pagi-item',
                bulletActiveClass: 'is-active',
                clickable: true,
            },
            breakpoints : {
                768: {
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                    pagination: {
                        enabled: false,
                    },
                    navigation: {
                        nextEl: this.querySelector('.home-news-nav-item.next'),
                        prevEl: this.querySelector('.home-news-nav-item.prev'),
                    },
                    scrollbar: {
                        el: this.querySelector('.home-news-list-scroller-inner'),
                        draggable: true,
                        dragClass: 'home-news-list-scroller-thumb',
                        dragSize: window.innerWidth > 991 ? parseRem(206) : parseRem(103),
                        snapOnRelease: true,
                    },
                }
            }
        })
    }
}
customElements.define('home-news', HomeNews);